import Box from '@mui/material/Box';
import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { PageHeader } from '@openx/components-header/PageHeader';
import { InsightsGrid } from './components/InsightsGrid/InsightsGrid';
import { InsightsTile } from './components/InsightsTile/InsightsTile';
import { tiles } from './config';
import { useHouseholdInsightsAccess } from './hooks/useHouseholdInsightsAccess';

export const HouseholdInsightsPage = () => {
  const hasAccess = useHouseholdInsightsAccess();

  if (!hasAccess) {
    return <AccessForbiddenPage />;
  }

  return (
    <PageHeader
      title="Household Insights"
      subtitle="Audience profile charts are household-based unless otherwise noted."
      titlePrefix="OpenXSelect"
    >
      <Box data-test="household-insights-page" sx={{ bgcolor: 'background.default', flexGrow: 1 }}>
        <InsightsGrid>
          {tiles.map(({ id, columns, component, disablePadding }) => (
            <InsightsTile key={id} columns={columns} component={component} disablePadding={disablePadding} />
          ))}
        </InsightsGrid>
      </Box>
    </PageHeader>
  );
};
